module.exports = __webpack_public_path__ + "static/media/helio-chagas.a5c88c7a.webp";